import { Schema } from 'effect';

/**
 * Canonical list of integration provider IDs. Narrowed as a string-literal union
 * so `session.user.enabledIntegrations` can be matched exhaustively on the
 * client. Add new providers here when wiring up new integrations.
 *
 * A leaf module on purpose: `session.ts` carries runtime schemas that only
 * exist for their types, and a browser import of these constants must not drag
 * them along.
 */
export const INTEGRATION_PROVIDERS = [
  'zotero',
  'dropbox',
  'google-drive',
] as const;
export type IntegrationProvider = (typeof INTEGRATION_PROVIDERS)[number];

const INTEGRATION_PROVIDER_SET = new Set<string>(INTEGRATION_PROVIDERS);
export const isIntegrationProvider = (p: string): p is IntegrationProvider =>
  INTEGRATION_PROVIDER_SET.has(p);

export const IntegrationProviderSchema = Schema.Literals([
  ...INTEGRATION_PROVIDERS,
]);

export const CloudStorageProviderSchema = IntegrationProviderSchema.pick([
  'dropbox',
  'google-drive',
]);
export type CloudStorageProvider = typeof CloudStorageProviderSchema.Type;

export const IntegrationConnectionFailureReasonSchema = Schema.Literals([
  'expired',
  'not_authenticated',
  'permission_denied',
  'unavailable',
  'failed',
]);
export type IntegrationConnectionFailureReason =
  typeof IntegrationConnectionFailureReasonSchema.Type;
